<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
		<path
			d="M35.1724 54.8276C35.1724 57.6842 32.8566 60 30 60H5.17241C3.8006 60 2.48498 59.455 1.51497 58.485C0.544949 57.515 0 56.1994 0 54.8276V5.17241C0 2.31577 2.31577 0 5.17241 0H30C31.3718 0 32.6874 0.544949 33.6575 1.51496C34.6275 2.48498 35.1724 3.8006 35.1724 5.17241V54.8276Z"
			fill="url(#paint0_linear_5391_45031)" />
		<path
			d="M35.1724 5.17241V7.24138C35.1724 7.24138 1.92414 7.24138 0.0827586 55.7379C0.0291072 55.4374 0.00141883 55.1328 0 54.8276V5.17241C0 2.31577 2.31577 0 5.17241 0H30C31.3718 0 32.6874 0.544949 33.6575 1.51496C34.6275 2.48498 35.1724 3.8006 35.1724 5.17241Z"
			fill="url(#paint1_linear_5391_45031)" />
		<path
			d="M28.9657 0L26.4343 5.06276C26.0839 5.76391 25.3674 6.20687 24.5836 6.2069H10.5891C9.80528 6.20687 9.08878 5.76391 8.73841 5.06276L6.20703 0H28.9657Z"
			fill="white" />
		<path
			d="M25.8616 56.8966H9.30987C8.73854 56.8966 8.27539 56.4334 8.27539 55.8621C8.27539 55.2908 8.73854 54.8276 9.30987 54.8276H25.8616C26.4329 54.8276 26.8961 55.2908 26.8961 55.8621C26.8961 56.4334 26.4329 56.8966 25.8616 56.8966Z"
			fill="white" />
		<path
			d="M20.6901 23.7931L8.82047 30.1241C8.4859 30.3047 8.27734 30.6542 8.27734 31.0344C8.27734 31.4146 8.4859 31.7642 8.82047 31.9448L20.6901 38.2758V45.5172C20.6901 48.3738 23.0059 50.6896 25.8625 50.6896H54.8281C57.6847 50.6896 60.0005 48.3738 60.0005 45.5172V16.5517C60.0005 13.695 57.6847 11.3793 54.8281 11.3793H25.8625C23.0059 11.3793 20.6901 13.695 20.6901 16.5517V23.7931Z"
			fill="white" />
		<path
			d="M50.3864 34.8693L41.076 44.1796C40.6721 44.5835 40.0172 44.5835 39.6133 44.1796L30.3029 34.8693C30.0071 34.5734 29.9187 34.1286 30.0788 33.7421C30.2388 33.3556 30.616 33.1035 31.0343 33.1034H35.1722V18.6207C35.1722 18.0493 35.6354 17.5862 36.2067 17.5862H44.4826C45.0539 17.5862 45.517 18.0493 45.517 18.6207V33.1034H49.655C50.0733 33.1035 50.4504 33.3556 50.6105 33.7421C50.7706 34.1286 50.6821 34.5734 50.3864 34.8693Z"
			fill="url(#paint2_linear_5391_45031)" />
		<defs>
			<linearGradient id="paint0_linear_5391_45031" x1="0" y1="45" x2="0" y2="45" gradientUnits="userSpaceOnUse">
				<stop stop-color="#F45484" />
				<stop offset="1" stop-color="#F51E78" />
			</linearGradient>
			<linearGradient id="paint1_linear_5391_45031" x1="0" y1="41.8034" x2="0" y2="41.8034"
				gradientUnits="userSpaceOnUse">
				<stop stop-color="#F45484" />
				<stop offset="1" stop-color="#F51E78" />
			</linearGradient>
			<linearGradient id="paint2_linear_5391_45031" x1="30" y1="37.7584" x2="50.6893" y2="37.7584"
				gradientUnits="userSpaceOnUse">
				<stop stop-color="#F45484" />
				<stop offset="1" stop-color="#F51E78" />
			</linearGradient>
		</defs>
	</svg>
</template>